import api from "../../../api";

export function getFailedUniOrders(page = 1) {
    return api.get(`get-failed-uni-orders?pageNumber=${page}`);
}

export function postFailedUniOrders(payload) {
    return api.put(`update-order-status?category=bulk_uni_sales_order_creation`, payload);
}
